import axios, { Axios } from "axios";

export type ProductsDatasourceOption = {
  id: string;
  title: string;
};

export type GetProductsDatasourceResponse = {
  products: ProductsDatasourceOption[];
};

export async function fetchProductsDatasource(
  tag: string
) {
  const response = await axios.get<GetProductsDatasourceResponse>(
    `${import.meta.env.VITE_API_V2_URL}/shop/products/datasource?tag=${tag}`
  );
  return response.data;
}
